<section class="flex flex-col items-center gap-12">
  <app-section-header
    [icon]="'@tui.check-circle'"
    [subtitle]="'Success'"
    [title]="'Your Device Information'"
  >
  </app-section-header>
  <div class="flex w-full flex-col gap-4 md:w-2/3 lg:w-1/2">
    <label tuiLabel>
      UDID
      <tui-textfield>
        <input [readOnly]="true" tuiTextfield [value]="udid()" />
        <tui-icon tuiCopy />
      </tui-textfield>
    </label>
    @if (deviceName()) {
      <label tuiLabel>
        Device Name
        <tui-textfield>
          <input [readOnly]="true" tuiTextfield [value]="deviceName()" />
          <tui-icon tuiCopy />
        </tui-textfield>
      </label>
    }
    @if (serial()) {
      <label tuiLabel>
        Serial Number
        <tui-textfield>
          <input [readOnly]="true" tuiTextfield [value]="serial()" />
          <tui-icon tuiCopy />
        </tui-textfield>
      </label>
    }
    @if (imei()) {
      <label tuiLabel>
        IMEI
        <tui-textfield>
          <input [readOnly]="true" tuiTextfield [value]="imei()" />
          <tui-icon tuiCopy />
        </tui-textfield>
      </label>
    }
    @if (meid()) {
      <label tuiLabel>
        MEID
        <tui-textfield>
          <input [readOnly]="true" tuiTextfield [value]="meid()" />
          <tui-icon tuiCopy />
        </tui-textfield>
      </label>
    }
    @if (version()) {
      <label tuiLabel>
        iOS Version
        <tui-textfield>
          <input [readOnly]="true" tuiTextfield [value]="version()" />
          <tui-icon tuiCopy />
        </tui-textfield>
      </label>
    }
    @if (product()) {
      <label tuiLabel>
        Product
        <tui-textfield>
          <input [readOnly]="true" tuiTextfield [value]="product()" />
          <tui-icon tuiCopy />
        </tui-textfield>
      </label>
    }
    <p class="mt-4 text-balance text-center text-base">
      To remove the profile, go to
      <strong>Settings > General > VPN & Device Management</strong>
      , select the profile, and tap
      <strong>Remove Profile</strong>
      .
    </p>
  </div>
</section>
